import { getVirtualizedAppNameInternal } from "../src/View/Hooks/useVirtualizedApp";
import VirtualizedAppService from "../src/Services/VirtualizedApp.service";
import PersonTypeService from "../src/Services/PersonType.service";
const addClassToSelector = (selector, className) => {
    $(selector).addClass(className);
};
const removeClassFromSelector = (selector, className) => {
    $(selector).removeClass(className);
};
const navbarChangeHandler = (location) => {
    const locations = [
        {
            testRegEx: /\/app\/report/,
            classAdders: [
                {
                    selector: "li.reports",
                },
            ],
        },
        {
            testRegEx: /\/app\/advisor\/home/,
            classAdders: [
                {
                    selector: "li.js-home",
                },
            ],
        },
        {
            testRegEx: /\/app\/roster/,
            classAdders: [
                {
                    selector: "li.js-roster",
                },
            ],
        },
        {
            testRegEx: /\/app\/campaign/,
            classAdders: [
                {
                    selector: "li.js-campaign",
                },
            ],
        },
        {
            testRegEx: /\/app\/advisor\/people/,
            classAdders: [
                {
                    selector: "li.js-people",
                },
            ],
        },
        {
            testRegEx: /\/app\/messages/,
            classAdders: [
                {
                    selector: "li.js-messages",
                },
            ],
        },
        {
            testRegEx: /\/app\/meetingRequest/,
            classAdders: [
                {
                    selector: "li.js-meeting-request-nav-title",
                },
            ],
        },
        {
            testRegEx: /\/app\/resourceGuide/,
            classAdders: [
                {
                    selector: "li.js-resources",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/profilePhotoUpload/,
            classAdders: [
                {
                    selector: "li.js-people-and-roles",
                    addClass: "open",
                },
                {
                    selector: "li.profilePhotoUpload",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/duplicateDetection/,
            classAdders: [
                {
                    selector: "li.js-people-and-roles",
                    addClass: "open",
                },
                {
                    selector: "li.duplicateDetection",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/lmsIntegration/,
            classAdders: [
                {
                    selector: "li.js-lms-integration",
                    addClass: "open",
                },
                {
                    selector: "li.js-lms-config",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/meetingType/,
            classAdders: [
                {
                    selector: "li.js-meetings",
                    addClass: "open",
                },
                {
                    selector: "li.js-meetingTypes",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/meetingModality/,
            classAdders: [
                {
                    selector: "li.js-meetings",
                    addClass: "open",
                },
                {
                    selector: "li.js-meeting-modality",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/serviceOffering/,
            classAdders: [
                {
                    selector: "li.js-meetings",
                    addClass: "open",
                },
                {
                    selector: "li.js-serviceOffering",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/serviceOffering/,
            classAdders: [
                {
                    selector: "li.js-meetings",
                    addClass: "open",
                },
                {
                    selector: "li.js-serviceOffering",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/messageReport/,
            classAdders: [
                {
                    selector: "li.js-message",
                    addClass: "open",
                },
                {
                    selector: "li.js-message-report",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/serviceDeliveryLocation/,
            classAdders: [
                {
                    selector: "li.js-meetings",
                    addClass: "open",
                },
                {
                    selector: "li.js-serviceDeliveryLocation",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/subscription\/batchExpire/,
            classAdders: [
                {
                    selector: "li.js-subscription",
                    addClass: "open",
                },
                {
                    selector: "li.js-subscription-batchexpire",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/subscription\/info/,
            classAdders: [
                {
                    selector: "li.js-subscription",
                    addClass: "open",
                },
                {
                    selector: "li.js-subscription-info",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/connectorConfiguration/,
            classAdders: [
                {
                    selector: "li.js-sis-integration",
                    addClass: "open",
                },
                {
                    selector: "li.js-connector-configuration",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/surveyAdmin/,
            classAdders: [
                {
                    selector: "li.js-survey",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/surveyAdmin\/index/,
            classAdders: [
                {
                    selector: "li.js-surveys",
                    addClass: "open",
                },
            ],
        },
        {
            testRegEx: /\/app\/survey/,
            classAdders: [
                {
                    selector: "li.js-surveys",
                    addClass: "open",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/taskAdmin\//,
            classAdders: [
                {
                    selector: "li.js-task",
                    addClass: "open",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/taskAdmin\/(template|index)/,
            classAdders: [
                {
                    selector: "li.js-task-template",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/taskAdmin\/actionplan/,
            classAdders: [
                {
                    selector: "li.js-task-actionplan",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/taskAdmin\/reassigntasks/,
            classAdders: [
                {
                    selector: "li.js-task-reassign",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/teamAdmin/,
            classAdders: [
                {
                    selector: "li.js-team",
                    addClass: "active open",
                },
                {
                    selector: "li.js-team-admin",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/admissions/,
            classAdders: [
                {
                    selector: "li.js-application-receipt",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/lmsCourseResolverError/,
            classAdders: [
                {
                    selector: "li.js-lms-integration",
                    addClass: "open",
                },
                {
                    selector: "li.js-lmsCourseResolverError",
                },
            ],
        },
        {
            testRegEx: /\/app\/admin\/lmsImportError/,
            classAdders: [
                {
                    selector: "li.js-lms-integration",
                    addClass: "open",
                },
                {
                    selector: "li.js-lmsImportError",
                },
            ],
        },
    ];
    // If a location matches, we want to add the class name to the selector.
    // If the page doesn't match, we want to remove active and any other added classes from the selector.
    // We have to be careful, though.  One location could match and have the same selector as a subsequent location which
    // doesn't match.  In that case, we want the matching location to "win".  In other words, we remove the class
    // only if no other selector matches it.
    // To do this, we construct a map of the selectors that match and a separate map of the selectors that don't match
    // We then only remove the classes in the map that doesn't match if they don't exist for that selector in the matched map.
    const matchedSelectors = {};
    const notMatchedSelectors = {};
    // populate the maps
    locations.forEach((loc) => {
        const matched = loc.testRegEx.test(location.pathname);
        const mapToAddTo = matched ? matchedSelectors : notMatchedSelectors;
        loc.classAdders.forEach((cAdder) => {
            var _a, _b, _c;
            // always add active and add other classes if specified.
            const classesToAdd = ["active"].concat((_b = (_a = cAdder.addClass) === null || _a === void 0 ? void 0 : _a.split(" ")) !== null && _b !== void 0 ? _b : []);
            mapToAddTo[cAdder.selector] = ((_c = mapToAddTo[cAdder.selector]) !== null && _c !== void 0 ? _c : []).concat(classesToAdd);
        });
    });
    // Add all the classes
    Object.entries(matchedSelectors).forEach(([selector, classesToAdd]) => {
        addClassToSelector(selector, classesToAdd.join(" "));
    });
    // Remove the classes as long as there isn't a match
    Object.entries(notMatchedSelectors).forEach(([selector, classesToRemove]) => {
        removeClassFromSelector(selector, classesToRemove
            .filter((classToRemove) => { var _a; return !((_a = matchedSelectors[selector]) === null || _a === void 0 ? void 0 : _a.includes(classToRemove)); })
            .join(" "));
    });
};
// keep track of the last app we called the handler on
// @ts-expect-error - TS7034 - Variable 'lastAppName' implicitly has type 'any' in some locations where its type cannot be determined.
let lastAppName = null;
// @ts-expect-error - TS7034 - Variable 'lastPersonType' implicitly has type 'any' in some locations where its type cannot be determined.
let lastPersonType = null;
const appChangeHandler = (location) => {
    const features = [
        {
            internalName: "headerPlans",
            href: "/app/advisor/plans",
            linkSelector: "a.headerPlansLink",
            classAdders: [
                {
                    selector: "li.headerPlans",
                },
                {
                    selector: "a.headerPlans",
                },
            ],
        },
        {
            internalName: "headerHome",
            href: "/app/advisor/home",
            linkSelector: "a.headerHomeLink",
            classAdders: [
                {
                    selector: "li.headerHome",
                },
                {
                    selector: "a.headerHome",
                },
            ],
        },
        {
            internalName: "headerCourses",
            href: "/controller/courseSection/list",
            linkSelector: "a.headerCoursesLink",
            classAdders: [
                {
                    selector: "li.headerCourses",
                },
                {
                    selector: "a.headerCourses",
                },
            ],
        },
        {
            internalName: "headerCampaigns",
            href: "/app/campaign/analysis",
            linkSelector: "a.headerCampaignsLink",
            classAdders: [
                {
                    selector: "li.headerCampaigns",
                },
                {
                    selector: "a.headerCampaigns",
                },
            ],
        },
        {
            internalName: "headerPipelines",
            href: "/app/pipeline",
            linkSelector: "a.headerPipelinesLink",
            classAdders: [
                {
                    selector: "li.headerPipelines",
                },
                {
                    selector: "a.headerPipelines",
                },
            ],
        },
        {
            internalName: "span.nav-app-name",
            replaceAppNameSelector: "span.nav-app-name",
        },
        {
            internalName: "headerPeople",
            href: "/app/advisor/people/",
            classAdders: [
                {
                    selector: "li.headerPeople",
                },
                {
                    selector: "a.headerPeople",
                },
                {
                    selector: "div.headerPeople",
                },
            ],
        },
        {
            internalName: "headerMeetingRequests",
            href: "/app/meetingRequest",
            linkSelector: "a.headerMeetingRequestsLink",
            classAdders: [
                {
                    selector: "li.headerMeetingRequests",
                },
                {
                    selector: "a.headerMeetingRequests",
                },
            ],
        },
        {
            internalName: "headerSurveys",
            linkSelector: "a.headerSurveysLink",
            href: "/controller/survey/index",
            classAdders: [
                {
                    selector: "li.headerSurveys",
                },
                {
                    selector: "a.headerSurveys",
                },
            ],
        },
    ];
    const virtualizedAppName = getVirtualizedAppNameInternal(location.pathname);
    // only figure out what features the app has if the app changed or the currentPersonType has changed
    const currentPersonType = location.pathname.substr(location.pathname.lastIndexOf("/people/") + "/people/".length);
    if (
    // @ts-expect-error - TS7005 - Variable 'lastAppName' implicitly has an 'any' type.
    (virtualizedAppName !== "app" && virtualizedAppName !== lastAppName) ||
        // @ts-expect-error - TS7005 - Variable 'lastPersonType' implicitly has an 'any' type.
        lastPersonType !== currentPersonType) {
        lastPersonType = currentPersonType;
        lastAppName = virtualizedAppName;
        VirtualizedAppService.getNavigationFeaturesForPassedApp(
        // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
        virtualizedAppName).then((applicableFeatures) => {
            features.forEach((feature) => {
                const operator = applicableFeatures
                    .map((f) => f.internalName)
                    .some((el) => el === feature.internalName)
                    ? removeClassFromSelector
                    : addClassToSelector;
                if (feature.classAdders) {
                    feature.classAdders.forEach((adder) => {
                        operator(adder.selector, "d-none");
                    });
                }
                if (feature.linkSelector && feature.href) {
                    $(feature.linkSelector).attr("href", "/aviso/" + virtualizedAppName + feature.href);
                }
                if (feature.replaceAppNameSelector) {
                    VirtualizedAppService.search({ query: virtualizedAppName }, { max: 1, offset: 0 }).then((app) => {
                        var _a;
                        $(feature.replaceAppNameSelector).text((_a = app[0]) === null || _a === void 0 ? void 0 : _a.displayName);
                    });
                }
                if (feature.internalName === "headerPeople") {
                    if (applicableFeatures
                        .map((f) => f.internalName)
                        .some((el) => el === "headerPeople")) {
                        const dropdown = $("div.headerPeopleList");
                        // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                        PersonTypeService.getPersonTypesForApp(virtualizedAppName).then((personTypes) => {
                            dropdown.empty();
                            if (personTypes.length > 1) {
                                removeClassFromSelector("div.headerMultiplePeople", "d-none");
                                addClassToSelector("a.headerSinglePeople", "d-none");
                                personTypes.forEach((personType) => {
                                    dropdown.append(('<a class="dropdown-item" href=/aviso/' +
                                        virtualizedAppName +
                                        "/app/advisor/people/" +
                                        personType.internalName +
                                        " >" +
                                        personType.name +
                                        "</a>").toString());
                                    removeClassFromSelector("a." + personType.internalName + "dropdown", "d-none");
                                });
                            }
                            else if (personTypes.length === 1) {
                                removeClassFromSelector("a.headerSinglePeople", "d-none");
                                addClassToSelector("div.headerMultiplePeople", "d-none");
                                $("a.headerSinglePeople").attr("href", "/aviso/" +
                                    virtualizedAppName +
                                    feature.href +
                                    personTypes[0].internalName);
                                $("a.headerSinglePeople").text(personTypes[0].name);
                                removeClassFromSelector("a." + personTypes[0].internalName + "dropdown", "d-none");
                            }
                            else {
                                addClassToSelector("a.headerSinglePeople", "d-none");
                                addClassToSelector("div.headerMultiplePeople", "d-none");
                            }
                        });
                        if (location.pathname.includes("/app/advisor/people")) {
                            $("#peopleEngageHeaderButton").text(currentPersonType.charAt(0).toUpperCase() +
                                currentPersonType.slice(1));
                        }
                    }
                }
            });
        });
    }
};
const hideSearchBar = (location) => {
    if (location.pathname.includes("/app/resourceGuide")) {
        $(".js-navbar-person-search-container").addClass("d-none");
    }
    else {
        $(".js-navbar-person-search-container").removeClass("d-none");
    }
};
const handlers = [
    navbarChangeHandler,
    appChangeHandler,
    hideSearchBar,
];
export default handlers;
